import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { isWorkspaceV2Path } from 'dashboard/helper/workspaceV2';

export const workspacePreferenceFailed = ref(false);

export function useWorkspaceV2() {
  const route = useRoute();
  const isWorkspaceV2 = computed(() => isWorkspaceV2Path(route?.path));
  return { isWorkspaceV2 };
}
